module.exports = __webpack_public_path__ + "static/media/18.bc9763f0.png";